import { createWave, play, pause } from './path-wave';

const $waves = document.querySelectorAll('.wave');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const waveDefaults = { amplitude: 24, length: 700, duration: 7000 };

if ($waves.length && !reducedMotion.matches) {
    const waves = new Map();

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const wave = waves.get(entry.target);

            if (entry.isIntersecting) {
                play(wave);
            } else {
                pause(wave);
            }
        });
    });

    $waves.forEach(($wave) => {
        waves.set($wave, createWave($wave, waveDefaults));
        observer.observe($wave);
    });
}
